module.exports = __webpack_public_path__ + "static/wellconnection-5640a0e78353d2ad78968e99655b6db6.png";